import { BffApiCreateItemError, UpdateItemGqlError } from '../../../../types';

import {
  StripeAttemptID,
  StripeAttemptPaymentUrl,
  StripeAttemptSessionClientSecret,
  StripeAttemptWithPaymentUrl,
  StripeAttemptWithSessionClientSecret,
  CreateStripeAttemptCacheKeys
} from '../../stripeAttemptsTypes';

import { InvoiceID } from '../../../invoices/invoicesTypes';
import { UpdateBillGqlStatus } from '../../../bills/billsTypes';

import { CACHE_CREATE_STRIPE_ATTEMPT_QUERY } from '../../queries/cacheCreateStripeAttempt.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CreateStripeAttemptOptions {
  cacheKeys?: CreateStripeAttemptCacheKeys;
}

interface CreateStripeAttemptInput {
  invoiceId: InvoiceID;
  withPaymentUrl?: StripeAttemptWithPaymentUrl;
  withSessionClientSecret?: StripeAttemptWithSessionClientSecret;
}

type CreateStripeAttemptError = BffApiCreateItemError;

interface CreateStripeAttemptItemType {
  id: StripeAttemptID;
  paymentUrl: StripeAttemptPaymentUrl;
  sessionClientSecret: StripeAttemptSessionClientSecret;
}

interface CreateStripeAttemptResponseType {
  createStripeAttempt: {
    status: UpdateBillGqlStatus;
    record: CreateStripeAttemptItemType;
    errors: UpdateItemGqlError;
    recordId: InvoiceID;
  };
}

const action = 'createStripeAttempt';

function useCacheCreateStripeAttempt({
  cacheKeys
}: CreateStripeAttemptOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryErrorMessage,
    createCacheQueryLoading
  } = useCacheCreateQuery<
    CreateStripeAttemptInput,
    CreateStripeAttemptResponseType,
    CreateStripeAttemptError,
    CreateStripeAttemptItemType
  >({ action, query: CACHE_CREATE_STRIPE_ATTEMPT_QUERY, cacheKeys });

  return {
    createStripeAttemptLoading: createCacheQueryLoading,
    createStripeAttemptErrorMessage: createCacheQueryErrorMessage,
    createStripeAttempt: createCacheQuery
  };
}

export default useCacheCreateStripeAttempt;
